import {useSelector} from "react-redux"
import useExperimentVariant from "@/hooks/useExperimentVariant"
import {GET_OFFER, GET_OFFER_TYPE} from "@/store/slices/offerSlice"

export const OFFER_DETAILS_EXPERIMENT_NAME = "offer_details_highlight"
export const OFFER_DETAILS_TEST_VALUE = "test"

/** offer_types que o experimento cobre — o teste é só pra ofertas digitais */
const DIGITAL_OFFER_TYPES = ['digital_basica', 'digital_completa']

const useOfferDetailsVariant = (): boolean | null => {
    const oferta = useSelector(GET_OFFER)
    const offer_type = useSelector(GET_OFFER_TYPE)

    // cortesia não tem preço pra destacar e parceiro (pré-pago) tem outro
    // fluxo — os dois caem em layouts que não são o do Zeplin
    const isElegivel = !!offer_type
        && DIGITAL_OFFER_TYPES.includes(offer_type)
        && !oferta?.is_cortesia
        && !oferta?.has_partner

    const variant = useExperimentVariant<"control" | "test">(
        OFFER_DETAILS_EXPERIMENT_NAME,
        "control",
        isElegivel
    )

    if (variant === null) {
        return null
    }

    return variant === OFFER_DETAILS_TEST_VALUE
}

export default useOfferDetailsVariant
